import "@/App.css";
import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import LoadingScreen from "@/components/LoadingScreen";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import Inventory from "@/pages/Inventory";
import Booking from "@/pages/Booking";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import SellYourCar from "@/pages/SellYourCar";
import EstimateRequest from "@/pages/EstimateRequest";
import LegalNotice from "@/pages/legal/LegalNotice";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import { Toaster } from "@/components/ui/sonner";
import "./i18n"; // Initialize i18n

function App() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <HelmetProvider>
      <div className="App">
        <LoadingScreen onLoadingComplete={() => setIsLoading(false)} />
        {!isLoading && (
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={
                <>
                  <Header />
                  <Home />
                  <Footer />
                </>
              } />
              <Route path="/inventory" element={
                <>
                  <Header />
                  <Inventory />
                  <Footer />
                </>
              } />
              <Route path="/inventory/:id" element={
                <>
                  <Header />
                  <Inventory />
                  <Footer />
                </>
              } />
              <Route path="/booking" element={
                <>
                  <Header />
                  <Booking />
                  <Footer />
                </>
              } />
              <Route path="/contact" element={
                <>
                  <Header />
                  <Contact />
                  <Footer />
                </>
              } />

              <Route path="/sell-your-car" element={
                <>
                  <Header />
                  <SellYourCar />
                  <Footer />
                </>
              } />

              <Route path="/estimer-mon-vehicule" element={
                <>
                  <Header />
                  <EstimateRequest />
                  <Footer />
                </>
              } />

              <Route path="/mentions-legales" element={
                <>
                  <Header />
                  <LegalNotice />
                  <Footer />
                </>
              } />

              <Route path="/politique-confidentialite" element={
                <>
                  <Header />
                  <PrivacyPolicy />
                  <Footer />
                </>
              } />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
            <CookieConsent />
            <Toaster position="top-right" />
          </BrowserRouter>
        )}
      </div>
    </HelmetProvider>
  );
}

export default App;
